export interface QuantityConstraints {
  minQuantity: number;
  maxQuantity: number;
  increment: number;
}

export function stripQuantitySeparators(value: string): string {
  return value.replace(/[,\s]/g, "");
}

export function parseQuantityInput(value: string): number | undefined {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const n = Number(trimmed);
  if (!Number.isInteger(n) || n <= 0) return undefined;

  return n;
}

export function getQuantityError(quantity: number, constraints: QuantityConstraints): string | undefined {
  const { minQuantity, maxQuantity, increment } = constraints;

  if (quantity < minQuantity || quantity > maxQuantity) {
    return `Quantity must be between ${minQuantity.toLocaleString()} and ${maxQuantity.toLocaleString()}`;
  }

  if (increment > 1 && quantity % increment !== 0) {
    return `Quantity must be a multiple of ${increment.toLocaleString()}`;
  }

  return undefined;
}
